(function () {
  const TARGET_CLASS = 'loox-v2-carousel-container';
  const NEW_PRODUCT_ID = '5558467657887';

  function fixLooxCarousel(container) {
    if (!container || container.offsetHeight > 0) return;

    const iframe = container.querySelector('iframe');
    if (!iframe || !iframe.src) return;

    // Replace productIds in iframe src
    const url = new URL(iframe.src);
    url.searchParams.set('productIds', NEW_PRODUCT_ID);
    iframe.src = url.toString();

    // Also update container data attribute (Loox reads this sometimes)
    container.setAttribute('data-product-ids', NEW_PRODUCT_ID);

    console.log('Loox carousel fixed → productIds:', NEW_PRODUCT_ID);
  }

  function addPosterRole(poster){
    if(poster){
      poster.setAttribute('role', 'presentation');
    }
  }

  // If already on page
  document.querySelectorAll(`.${TARGET_CLASS}`).forEach(fixLooxCarousel);

  // Watch for async insertion
  const observer = new MutationObserver(() => {
    document.querySelectorAll(`.${TARGET_CLASS}`).forEach(fixLooxCarousel);
    document.querySelectorAll('video img').forEach(addPosterRole)
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
})();
